"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTestTypeStandard = exports.isTestTypeLate = exports.isTestTypeException = exports.isIntentYes = exports.isIntentUnused = exports.isIntentUndecided = exports.isIntentNoOther = exports.isIntentNo = exports.STANDARD_TYPE = exports.LATE_TYPE = exports.INTENT_YES = exports.INTENT_UNUSED = exports.INTENT_UNDECIDED = exports.INTENT_NOOTHER = exports.INTENT_NO = exports.EXCEPTION_TYPE = void 0;

/* EXAM INTENT */
const INTENT_YES = 'YES';
exports.INTENT_YES = INTENT_YES;
const INTENT_NO = 'NO';
exports.INTENT_NO = INTENT_NO;
const INTENT_UNDECIDED = 'UNDECIDED';
exports.INTENT_UNDECIDED = INTENT_UNDECIDED;
const INTENT_UNUSED = 'UNUSED';
exports.INTENT_UNUSED = INTENT_UNUSED;
const INTENT_NOOTHER = 'NO_OTHER';
exports.INTENT_NOOTHER = INTENT_NOOTHER;

const isIntentYes = function (_ref) {
  let examIntent = _ref.examIntent;
  return examIntent === INTENT_YES;
};

exports.isIntentYes = isIntentYes;

const isIntentNo = function (_ref2) {
  let examIntent = _ref2.examIntent;
  return examIntent === INTENT_NO;
};

exports.isIntentNo = isIntentNo;

const isIntentUndecided = function (_ref3) {
  let examIntent = _ref3.examIntent;
  return examIntent === INTENT_UNDECIDED;
};

exports.isIntentUndecided = isIntentUndecided;

const isIntentUnused = function (_ref4) {
  let examIntent = _ref4.examIntent;
  return examIntent === INTENT_UNUSED;
};

exports.isIntentUnused = isIntentUnused;

const isIntentNoOther = function (_ref5) {
  let examIntent = _ref5.examIntent;
  return examIntent === INTENT_NOOTHER;
};
/* EXAM TEST TYPE */


exports.isIntentNoOther = isIntentNoOther;
const STANDARD_TYPE = 'STANDARD';
exports.STANDARD_TYPE = STANDARD_TYPE;
const LATE_TYPE = 'LATE';
exports.LATE_TYPE = LATE_TYPE;
const EXCEPTION_TYPE = 'EXCEPTION';
exports.EXCEPTION_TYPE = EXCEPTION_TYPE;

const isTestTypeStandard = function (_ref6) {
  let testDayType = _ref6.testDayType;
  return testDayType === STANDARD_TYPE;
};

exports.isTestTypeStandard = isTestTypeStandard;

const isTestTypeLate = function (_ref7) {
  let testDayType = _ref7.testDayType;
  return testDayType === LATE_TYPE;
};

exports.isTestTypeLate = isTestTypeLate;

const isTestTypeException = function (_ref8) {
  let testDayType = _ref8.testDayType;
  return testDayType === EXCEPTION_TYPE;
};

exports.isTestTypeException = isTestTypeException;